import InfiniteClick from './modules/InfiniteClick';
import Megamenu from './modules/Megamenu';

new InfiniteClick();
new Megamenu();
